import React from "react";
import {
  BusinessContact,
  SocialMediaButtonsGrid,
  FishermanLabel
} from "@fishrmn/fishrmn-components";

import Link from "gatsby-link";
import "../../css/footer.scss";
import { socialMediaConfig } from "../../../config/config";
import NutritionFacts from "../../data/Whole Sol Nutrition Facts (1).pdf";

const companyInfo = {
  // phone: "(720) 372-7862",
  address: "",
  email: "HI@WHOLESOL.COM"
};

const Footer = () => (
  <div id="footer-container">
    <div>
      <BusinessContact companyInfo={companyInfo} withIcons={false} />
    </div>
    <div id="footer-join-us">
      <a
        href="https://app.joinhomebase.com/cmp/whole-sol-blend-bar"
        target="_blank"
        rel="noopener"
      >
        <button>JOIN US</button>
      </a>
    </div>
    <div id="footer-social-media">
      <SocialMediaButtonsGrid socialMediaConfig={socialMediaConfig} />
    </div>
    <div id="footer-stripe">
      <span>
        <div>® 2023 WHOLE SOL GROUP HOLDINGS LLC</div>
        <a
          href="mailto:hi@wholesol.com"
          style={{
            color: "white",
            textDecoration: "underline"
          }}
        >
          Contact Us
        </a>
        <a
          href="https://squareup.com/outreach/jgPw2j/subscribe"
          style={{
            color: "white",
            textDecoration: "underline",
            marginLeft: "0.5rem"
          }}
        >
          Join our Email List!
        </a>
      </span>
      <span>
        <FishermanLabel />
      </span>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx